import React from "react";
import { Fade } from "react-reveal";
import SubHeader from "../components/SubHeader";
import "./WhatWeDo.css";

export default function WhatWeDo() {
  return (
    <>
      <section className="what-we-do" id="what-we-do">
        <div className="container">
          <Fade up>
            <div className="what-we-do-img col-lg-3"></div>
          </Fade>
          <Fade up>
            <div className="what-we-do-context col-lg-9">
              <SubHeader
                title={"Our Academic Offerings"}
                subheader={
                  "Comprehensive Education for Every Stage of Your Child’s Journey"
                }
              />

              <p>
                Wellingtonia International School offers a holistic educational
                experience, guiding students from their foundational years all
                the way through to advanced qualifications. Our curriculum is
                designed to nurture both academic excellence and personal
                growth, ensuring each child is well-prepared for their future.
              </p>

              <p>
                Currently, we are enrolling students in the following levels:
              </p>
              <ul>
                <li>
                  <strong>Lower Primary:</strong> Year 1 to Year 3
                </li>
                <li>
                  <strong>Upper Primary:</strong> Year 4 to Year 6
                </li>
                <li>
                  <strong>Lower Secondary:</strong> Year 7 to Year 9
                </li>
                <li>
                  <strong>Upper Secondary (IGCSE):</strong> Year 10 & Year 11
                </li>
              </ul>

              <p>
                Wellingtonia’s commitment to flexible learning ensures that your
                child’s educational journey can be personalized to their unique
                strengths and goals. Whether they are just beginning in primary
                school or preparing for higher education, Wellingtonia provides
                the foundation they need to succeed.
              </p>

              <a
                className="join-wellingtonia"
                href="https://forms.gle/UE7YqR5ni6XUtzip9"
                rel="noreferrer"
                target={"_blank"}
              >
                Join now{" "}
              </a>
            </div>
          </Fade>
        </div>
      </section>
      <hr style={{ color: "#000", position: "relative", zIndex: 12343 }} />
    </>
  );
}
